import React from 'react';
import './AITools.css';

const AITools = () => {
  const tools = [
    { name: 'ChatGPT', logo: 'https://upload.wikimedia.org/wikipedia/commons/0/04/ChatGPT_logo.svg' },
    { name: 'Jasper', logo: 'https://mediaresource.sfo2.digitaloceanspaces.com/wp-content/uploads/2024/04/20233159/jasper-logo-644795359F-seeklogo.com.png' },
    { name: 'Copy.ai', logo: 'https://gdm-catalog-fmapi-prod.imgix.net/ProductLogo/5c992120-216b-48a4-a99a-1f39177143f1.png' },
    { name: 'Canva', logo: 'https://logos-world.net/wp-content/uploads/2020/02/Canva-Logo.png' },
    { name: 'Grammarly', logo: 'https://brandlogo.org/wp-content/uploads/2024/06/Grammarly-Logo.png.webp' },
    { name: 'Notion', logo: 'https://upload.wikimedia.org/wikipedia/commons/4/45/Notion_app_logo.png' },
    { name: 'Pictory', logo: 'https://pictory.ai/wp-content/uploads/2022/03/logo-new-fon-2t.png' },
    { name: 'Synthesia', logo: 'https://logos-download.com/wp-content/uploads/2024/04/Synthesia_Logo.png' },
    { name: 'Surfer SEO', logo: 'https://marketing-assets.surferseo.art/wf-cdn/62666115cfab458794bd512f/65df5d7e56cf9a3414790226_Logo%20-%20Surfer.png' },
    { name: 'Writesonic', logo: 'https://images.softwaresuggest.com/software_logo/1680614090_6ec8846d-aa3a-40a8-a44a-c5b332dd.png' },
    { name: 'Quillbot', logo: 'https://1000logos.net/wp-content/uploads/2023/11/QuillBot-Logo-2017.png' },
    { name: 'Midjourney', logo: 'https://registry.npmmirror.com/@lobehub/icons-static-png/latest/files/light/midjourney-text.png' },
    { name: 'DALL·E', logo: 'https://freelogopng.com/images/all_img/1683823510dall-e-logo-png.png' },
    { name: 'Lumen5', logo: 'https://storage.googleapis.com/lumen5-site-images/L5-logo/L5-logo-color-default.svg' },
    { name: 'Descript', logo: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSgBhiBajsqyYlF99gR3qjudugQzVKNPiJWbA&s' },
    { name: 'Semrush AI', logo: 'https://prowly-prod.s3.eu-west-1.amazonaws.com/uploads/60169/assets/601030/-41b7df259e181179ec6cf7184d77bffe.png' },
    { name: 'HubSpot AI', logo: 'https://upload.wikimedia.org/wikipedia/commons/7/71/HubSpot_Logo.png' },
    { name: 'Zapier AI', logo: 'https://upload.wikimedia.org/wikipedia/commons/0/02/Zapier_logo.png' },
    { name: 'Tome AI', logo: 'https://www.brookergroup.com/wp-content/uploads/2023/06/tome-logo-AI.02.png' },
  ];

  return (
    <div className="aitools-section">
      <h2 className="aitools-title">AI Tools We Cover</h2>
      <div className="aitools-marquee">
        <div className="aitools-track">
          {tools.map((tool, index) => (
            <div key={index} className="aitools-logo">
              <img src={tool.logo} alt={tool.name} />
              <span>{tool.name}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default AITools;
